import { MealSwapFilterOptionWithSubFilters } from "@/clients/models/MealSwapFilterOptionWithSubFilters";
import { PillButton } from "@/components/ui/buttons/PillButton";
import { cn } from "@/utils/cn";
import { memo } from "react";
import { getMainFilterIcon } from "../../utils/get-lifestyle-icon";

interface TopFilterButtonsProps {
  options: MealSwapFilterOptionWithSubFilters[];
  selectedValue: string;
  labels: Record<string, string>;
  onSelect: (value: string) => void;
}

export const TopFilterButtons = memo(function TopFilterButtons({
  options,
  selectedValue,
  labels,
  onSelect,
}: TopFilterButtonsProps) {
  return (
    <div className="relative">
      <div className="no-scrollbar flex items-center gap-2 overflow-x-auto">
        {options.map((option) => {
          const isActive = option.value === selectedValue;
          const optionLabel = labels[option.value] ?? option.name;
          const icon = getMainFilterIcon(
            option.value,
            isActive ? "h-4 w-4 fill-white" : "h-4 w-4 fill-pill-action",
          );
          return (
            <PillButton
              key={option.value}
              selected={isActive}
              onClick={() => onSelect(option.value)}
              className={cn(
                "h-[38px] px-3",
                "flex items-center gap-1 border-transparent whitespace-nowrap",
                isActive
                  ? "bg-[linear-gradient(90deg,#16458D_0%,#1B64D4_100%)] text-white"
                  : "text-pill-action bg-transparent",
              )}
            >
              {icon}
              <span>{optionLabel}</span>
            </PillButton>
          );
        })}
      </div>
      <div className="pointer-events-none absolute top-0 -right-1 h-full w-10 bg-gradient-to-l from-white to-transparent" />
    </div>
  );
});
